import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, { resetAllState } from "./Reducer/authSlice";
import DoctorSlice from "./Reducer/Doctor/DoctorSlice";
import OrderSlice from "./Reducer/Order/OrderSlice";
import StoreSlice from "./Reducer/Store/StoreSlice";
import partnerSlice from "./Reducer/Admin/PartnerSlice";
import ProductSlice from "./Reducer/Product/ProductSlice";
import adminSlice from "./Reducer/AdminAccount/AccountSlice";
import customerSlice from "./Reducer/Customer/CustomerSlice"
import lookupMarginSlice from "./Reducer/LookupMargin/MarginSlice"
import ReceiptSlice from "./Reducer/Receipt/ReceiptSlice";
import PrescriptionSlice from "./Reducer/Prescription/PrescriptionSlice";
import HealthMapSlice from "./Reducer/HealthMap/HealthMapSlice";
import QuickOrderSlice from "./Reducer/QuickOrder/QuickOrderSlice";
import AppointmentSlice from "./Reducer/Appointment/AppointmentSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  // whitelist: ["auth", "store", "admin","doctor"] // Reducers you want to persist
};

const appReducer = combineReducers({
  auth: authReducer,
  doctor: DoctorSlice,
  order: OrderSlice,
  store: StoreSlice,
  formSwitcher: partnerSlice,
  product: ProductSlice,
  admin: adminSlice,
  patient: customerSlice,
  lookup: lookupMarginSlice,
  receipt: ReceiptSlice,
  prescription: PrescriptionSlice,
  healthMap: HealthMapSlice,
  quickOrder: QuickOrderSlice,
  appointment: AppointmentSlice,
});
const rootReducer = (state, action) => {
  if (action.type === resetAllState.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});


// Create persistor for the store
export const persistor = persistStore(store);